module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-6.fc95c271.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-6.mp3
// module id = 128
// module chunks = 0